module.exports = __webpack_public_path__ + "img/0.b0ba7a58.png";